import Form from 'react-bootstrap/Form';
import React from 'react';
import './Radio.css'
import { useNavigate } from 'react-router-dom';

const Radio=({data,link,isChecked,isDisabled})=>{
  const navigate = useNavigate();
  return (
    <Form>
      {['radio'].map((type) => (
        <div key={`inline-${type}`} className="custom-radio">
          <Form.Check
            inline
            label={data}
            name="group1"
            disabled={isDisabled}
            onClick={()=>navigate(link)}
            type={type}
            checked={isChecked}
            id={`inline-${type}-1`}
          />
        </div>
      ))}
    </Form>
  );

}

export default Radio;